module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Saucepan-a8c9534667478997d465901c4475e2df.svg";